import React from 'react'
import './about.css'
import ME from '../../assests/IMG_0379.jpg'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'
const About = () => {
    return (
        <section id='about'>
            <h5>Get To Know</h5>
            <h2>About Me</h2>

            <div className='container about__container'>
                <div className="about__me">
                    <div className="about__me-image">
                        <img src={ME} alt='About Image' />
                    </div>
                </div>

                <div className="about__content">
                    <div className="about__cards">
                        <article className='about__card'>
                            <FaAward className='about__icon'/>
                            <h5>Experience</h5>
                            <small>BS Computer Engineering</small>
                        </article>

                        <article className='about__card'>
                            <VscFolderLibrary className='about__icon'/>
                            <h5>Projects</h5>
                        </article>
                    </div>
                    <p>
                        I am a Computer Engineering Graduate looking for a full-time AI, ML, or Software Engineering position.
                        I have undergraduate research experience through the National Science Foundation (NSF) Center for Space, 
                        High Performance, and Resilient Computing (SHREC) over the course of two summers. My first summer as 
                        an undergraduate researcher, I had the opportunity of working on the FPGA developement team to optimize
                        a Hierarchy of Event Based Time Surfaces (HOTS) Neuromorphic ML model for object detection. My second summer
                        I was a part of the Mission Software and Simulation (MSS) team where I benchmarked Emulation-In-the-Loop (EIL) 
                        vs Hardware-In-The-Loop (HIL) for sending/receiving communication latency. I also have project experience in creating
                        a full stack web application for my AI Powered Fitness Trainer that uses Google's DeepSeek model for pose detection and 
                        TinyLlama LLM for chatbot feedback. All other relevant projects you can see linked below or find on my GitHub.
                    </p>
                    <a href='#contact' className='btn btn primary'>Let's Talk</a>
                </div>
                </div>
        </section>
    )
}

export default About 